import React from "react";
import { ShieldCheck, X } from "lucide-react";
import "../../../assets/css/general/messagesafteymodal/MessageSafteyModal.css";

const MessageSafetyModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="safety-modal-overlay" onClick={onClose}>
      <div
        className="safety-modal"
        onClick={(e) => e.stopPropagation()}
      >

        {/* Close */}
        <button
          className="safety-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {/* Icon */}
        <div className="safety-modal-icon">
          <ShieldCheck size={34} strokeWidth={2} />
        </div>

        {/* Content */}
        <div className="safety-modal-content">
          <h2>Keep Your Conversation Safe</h2>

          <p>
            For your safety, please don't share personal contact
            details or payment information in chat.
          </p>

          <p className="safety-modal-note">
            Keep communication and payments safely within Picks4Tips.
          </p>
        </div>

        {/* Button */}
        <button
          className="safety-modal-button"
          onClick={onClose}
        >
          Got it
        </button>

      </div>
    </div>
  );
};

export default MessageSafetyModal;
